import React from "react";
import { Flex } from "./compositeComponents/FlexHelpers";
import { EmployeePortalFileLinkWithTokenRefresh, FileLinkWithTokenRefresh } from "./FileLinkWithTokenRefresh";
import { FileIcon } from "./FileIcon";
import { fileHelper } from "../utils/fileHelper";
import { LinkButton } from "./button/LinkButton";
import { apiEndpoints } from "../amorg-common";
import { ToggletipTheOne } from "./ToggletipTheOne";


type FileLinkListingProps = {
    publicFileName: string,
    privateFileName: string,
    size: number,
    employeePortalLink?: boolean,
    note?: string
}
export function FileLinkListing(props:FileLinkListingProps):JSX.Element
{
    return (
        <Flex gap={16} alignItems='center' width='100%' style={{ minWidth: 0 }}>
            <FileIcon {...props} />

            <div style={{ flex: '1 1 0', minWidth: 0, overflow: 'hidden' }}>
                {props.employeePortalLink
                    ?
                        <EmployeePortalFileLinkWithTokenRefresh
                            publicFileName={props.publicFileName}
                            privateFileName={props.privateFileName}
                            style={{ display:'block', overflow:'hidden', maxWidth:'100%' }} />
                    :
                        <FileLinkWithTokenRefresh
                            publicFileName={props.publicFileName}
                            privateFileName={props.privateFileName}
                            style={{ display:'block', overflow:'hidden', maxWidth:'100%' }} />
                }
            </div>

            {props.note && props.note.trim() !== '' &&
                <div style={{ flexShrink: 0 }}>
                    <ToggletipTheOne icon="interface_glyph_comment">
                        {props.note}
                    </ToggletipTheOne>
                </div>
            }

            <div style={{ fontSize:'14px', flexShrink: 0 }}>({fileHelper.sizeInKB(props.size)} KB)</div>
            
            <div style={{ flexShrink: 0 }}>
                <LinkButton
                    variant='dimmed'
                    text=''
                    icon='interface_actions_download'
                    href={
                        props.employeePortalLink
                            ? apiEndpoints.portalfiles_privateFileName.replace(':privateFileName', props.privateFileName)
                            : apiEndpoints.files_privateFileName.replace(':privateFileName', props.privateFileName)
                    }
                    download={props.publicFileName}
                />
            </div>
        </Flex>
    );
}